export default {
      id: "circle__steering-wheel-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__steering-wheel",
      toString: function () {
        return this.url;
      }
    }